<template>
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M19.875 11.0521H19.8398C18.2227 11.0521 16.7461 10.5599 15.5508 9.68103V15.974C15.5508 19.1381 12.9844 21.6693 9.82031 21.6693C6.65625 21.6693 4.125 19.1381 4.125 15.974C4.125 12.8099 6.65625 10.2435 9.82031 10.2435C10.1016 10.2435 10.3477 10.2787 10.6289 10.3138V13.4779C10.3477 13.3724 10.1016 13.3373 9.82031 13.3373C8.37891 13.3373 7.18359 14.5326 7.18359 15.974C7.18359 17.4154 8.37891 18.6107 9.82031 18.6107C11.2617 18.6107 12.457 17.4154 12.457 15.974V3.66931H15.5508C15.5508 3.70447 15.5508 3.70447 15.5508 3.73962C15.5508 3.98572 15.5508 4.23181 15.6211 4.47791C15.832 5.63806 16.5352 6.65759 17.5195 7.29041C18.1875 7.74744 18.9961 7.99353 19.8398 7.99353C19.8398 7.99353 19.8398 7.99353 19.875 7.99353V11.0521Z"
            fill="inherit"
        />
    </svg>
</template>
